import React from "react";
import Lottie from "lottie-react";
import checkAnimation from "../assets/check.json";

interface FooterState {
        message: string;
        type: "default" | "success" | "error";
}

interface FooterProps {
        defaultMessage: string;
}

export const useFooterState = () => {
        const [footerState, setFooterState] = React.useState<FooterState>({
                message: "",
                type: "default",
        });

        const showToast = React.useCallback(
                (message: string, type: FooterState["type"] = "default") => {
                        setFooterState({ message, type });
                },
                []
        );

        const resetToast = React.useCallback(() => {
                setFooterState({ message: "", type: "default" });
        }, []);

        return { footerState, showToast, resetToast };
};

export const Footer: React.FC<
        FooterProps & {
                footerState: FooterState;
                defaultMessage: string;
        }
> = ({ footerState, defaultMessage }) => {
        const message = footerState.message || defaultMessage;
        const className = `footer ${footerState.type}`;

        return (
                <div className={className}>
                        {footerState.type === "success" && (
                                <div className="lottie-container">
                                        <Lottie
                                                animationData={checkAnimation}
                                                loop={false}
                                                autoplay={true}
                                                style={{ width: "32px", height: "32px", paddingTop: "2px" }}
                                                rendererSettings={{
                                                        preserveAspectRatio: "xMidYMid slice"
                                                }}
                                        />
                                </div>
                        )}
                        <span>{message}</span>
                </div>
        );
};